import RoutePrivate from './RoutePrivate'

export default RoutePrivate



// WEBPACK FOOTER //
// ./src/components/RoutePrivate/index.js